import { Fragment, useContext } from 'react'
import { IproviderFundAcc, ProviderFundAccount } from './FundAccoutingForm';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import _ from "lodash";
import { parseFloatCheckValue } from '../Ticket/fnTickit';
import { Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { BtnAdd, BtnDeleteTable } from 'components/Button/ButtonAll';
import { I18n } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';
import InputReactNumber from '../InputReactNumber';
import { TextBoxItem } from 'components/Input/TextBox';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { ItemFundAcc } from './interfaceFundAcc';

interface ArrayField {
    nID: number;
    nOrder: number;
    isDelete?: boolean;
    isDisable?: boolean;
    isCanAdd?: boolean;
    isOther?: boolean;
    isCanDelete?: boolean;
    sExpenseID?: string;
    sName?: string;
    sTotal?: any;
    lstSubLevel?: ItemFundAcc[];
    id: string;
}

export const TableExpense = () => {

    const {
        isView,
        DialogFn,
        form,
        optionExpense,
        findMaxID,
        findValue,
        setEqualBalance
    } = useContext<IproviderFundAcc>(ProviderFundAccount);


    const { control, watch } = form;
    const { fields } = useFieldArray({
        control,
        name: "lstExpense"
    });

    const watchFieldArray = watch("lstExpense");
    const controlledFields: ArrayField[] = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });

    const calculateExpense = (value: any, nParentID: number | null) => {
       
        let lstExpense = _.cloneDeep(watch("lstExpense")) as ItemFundAcc[];

        if (nParentID) {
            lstExpense.forEach((element: ItemFundAcc, index: number) => {
                if (element.nOrder === nParentID && element.lstSubLevel != null && element.lstSubLevel.length !== 0) {
                    let sum = _.sumBy(element.lstSubLevel,  (o: ItemFundAcc)=>  { return parseFloatCheckValue(o.sTotal); });
                    element.sTotal = sum + "";
                    form.setValue(`lstExpense.${index}.sTotal`, sum + "")
                }
            });
        }

        let sumExpense = _.sumBy(lstExpense, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
        sumExpense = Number(sumExpense.toFixed(2));
        form.setValue("sTotalExpense", sumExpense + "")
        
        let nBringForward = parseFloatCheckValue(form.getValues("sBringForward")) ?? 0;
        let nTotalIncome = parseFloatCheckValue(form.getValues("sTotalIncome")) ?? 0;
        let calBalance = nBringForward + nTotalIncome - sumExpense;
        form.setValue("sBalance", calBalance + "")

        let nTotalMoreDetail  = parseFloatCheckValue(form.getValues("sTotalMoreDetail")) ?? 0;
        setEqualBalance(calBalance === nTotalMoreDetail)

    }

    const handleAddParent = () => {
        let lstExpense = watch("lstExpense");
        let deepCopy = _.cloneDeep(lstExpense) as ItemFundAcc[];
        let nIDMax = findMaxID(deepCopy);
        // Add Parent
        deepCopy.push({
            nID: null,
            nFundAccountingItemID: null,
            nOrder: nIDMax,
            sName: null,
            sExpenseID: null,
            isCanAdd: false,
            isCanDelete: true,
            isDelete: false,
            isDisable: false,
            sTotal: null,
            lstSubLevel: [],
        })
        form.setValue("lstExpense", deepCopy);
    }


    const handleAdd = (dataRow: ItemFundAcc, nParentID: number | null) => {
        let lstExpense = watch("lstExpense");
        let deepCopy = _.cloneDeep(lstExpense) as ItemFundAcc[];
        let nOrderMax = findMaxID(deepCopy);
        // Add In Sub Level
        let rowEdit: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", dataRow.nOrder);
        if (rowEdit) {
            let objAdd = {
                nID: null,
                nFundAccountingItemID : null,
                nOrder: nOrderMax,
                sName: null,
                sExpenseID: null,
                isCanAdd: true,
                isCanDelete: true,
                isOther: false,
                isDelete: false,
                isDisable: false,
                sTotal: null,
                lstSubLevel: [],
            } as ItemFundAcc

            if (!nParentID) {
                rowEdit.lstSubLevel.splice(0, 0, objAdd);
                form.setValue("lstExpense", deepCopy);
                form.reset({
                    ...form.watch(),
                    lstExpense : deepCopy
                });
                return;
            }

            //Find Index on handle
            let rowParent: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", nParentID);
            if (rowParent) {
                let nIndex = rowParent.lstSubLevel.findIndex(f => f.nOrder === dataRow.nOrder);
                if (nIndex > -1) {
                    rowParent.lstSubLevel.splice(nIndex + 1, 0, objAdd);
                }
            }
            form.setValue("lstExpense", deepCopy);
            form.reset({
                ...form.watch(),
                lstExpense : deepCopy
            });
        }
    }


    const handleDelete = (dataRow: ItemFundAcc) => {

        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            let lstExpense = watch("lstExpense");
            let deepCopy = _.cloneDeep(lstExpense) as ItemFundAcc[];
            let dtDelete: ItemFundAcc = findValue(deepCopy, "lstSubLevel", "nOrder", dataRow.nOrder);
            dtDelete.isDelete = true;
            const cleanIsDeleteInArray = removeDeletedItems(deepCopy);
            cleanIsDeleteInArray.forEach((element: ItemFundAcc, index: number) => {
                if (element.lstSubLevel != null && element.lstSubLevel.length !== 0) {
                    let sum = _.sumBy(element.lstSubLevel, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
                    element.sTotal = sum + "";
                    form.setValue(`lstExpense.${index}.sTotal`, sum + "")
                }
            });
            let sumExpense = _.sumBy(cleanIsDeleteInArray, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
        sumExpense = Number(sumExpense.toFixed(2));
        form.setValue("sTotalExpense", sumExpense + "")
            form.setValue("lstExpense", cleanIsDeleteInArray);

            let nBringForward = parseFloatCheckValue(form.getValues("sBringForward")) ?? 0;
            let nTotalIncome = parseFloatCheckValue(form.getValues("sTotalIncome")) ?? 0;
            let calBalance = nBringForward + nTotalIncome - sumExpense;
            form.setValue("sBalance", calBalance + "")

            let nTotalMoreDetail  = parseFloatCheckValue(form.getValues("sTotalMoreDetail")) ?? 0;
            setEqualBalance(calBalance === nTotalMoreDetail)

            DialogFn.CloseSubmit();
        });
    }

    const removeDeletedItems = (arr: ItemFundAcc[]) => {
        return arr.filter(item => !item.isDelete).map(item => {
            if (item.lstSubLevel && item.lstSubLevel.length > 0) {
                item.lstSubLevel = removeDeletedItems(item.lstSubLevel);
            }
            return item;
        });
    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Divider textAlign="left" className="font-weight-500">รายการรายจ่าย</Divider>
            </Grid>
            <Grid item xs={12}>
                {/* Table */}
                <TableContainer id='table-fundacc' component={Paper}>
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                                <TableCell component="th" >รายการ</TableCell>
                                <TableCell component="th" style={{ minWidth: '200px', width: '200px' }}>จำนวนเงิน (บาท)</TableCell>
                                <TableCell component="th" style={{ minWidth: '120px', width: '120px' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                controlledFields.map((row, index) => {
                                    const fieldName = `lstExpense.${index}`;
                                    let isHasSubLevel = row.lstSubLevel != null && row.lstSubLevel.length > 0;
                                    return (
                                        <RowExpense
                                            key={`${fieldName}.sID`}
                                            form={form}
                                            fieldName={fieldName}
                                            optionExpense={optionExpense}
                                            row={row}
                                            index={index}
                                            isHasSubLevel={isHasSubLevel}
                                            handleAdd={handleAdd}
                                            handleDelete={handleDelete}
                                            calculateExpense={calculateExpense}
                                            watch={watch}
                                        />
                                    )
                                })
                            }
                            {
                                controlledFields.length === 0 ?
                                    <TableRow >
                                        <TableCell align="center" colSpan={4}>ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                    :
                                    null
                            }
                            <TableRow sx={{ backgroundColor: "#e8be2a" }}>
                                <TableCell align="center" component="td" ></TableCell>
                                <TableCell align="center" component="td">รวมรายจ่าย</TableCell>
                                <TableCell component="td" className='text-right'>
                                    <InputReactNumber
                                        id={`sTotalExpense`}
                                        name={`sTotalExpense`}
                                        required={false}
                                        valueType='string'
                                        maxDigits={2}
                                        IsCanMinus={false}
                                        IsShowMessageError={false}
                                        disabled
                                    />
                                </TableCell>
                                <TableCell align="center" component="td" ></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

            </Grid>
            <Grid item xs={12}>
                {/* buttun Add */}
                {!isView && <BtnAdd id="btnAdd-expense" txt="เพิ่มรายการรายจ่าย" onClick={() => { handleAddParent() }} />}
            </Grid>
        </Grid>
    )
}


const RowExpense = ({ form, fieldName, optionExpense, row, index, isHasSubLevel, handleAdd, handleDelete, calculateExpense,watch }
    : {
        form: UseFormReturn<{
            dDate: any;
            sBringForward: any;
            sTotalIncome: any;
            sTotalExpense: any;
            sTotalMoreDetail: any;
            sBalance: any;
            lstIncome: ItemFundAcc[];
            lstExpense: ItemFundAcc[];
            lstMoreDetail: ItemFundAcc[];
        }, any, undefined>, fieldName: string, optionExpense, row: ArrayField, index, isHasSubLevel, handleAdd, handleDelete,
        calculateExpense: (value: any, nParentID: number | null) => void
        watch : any
    }
) => {


    const {
        isView,
        DialogFn,
        handleSelectExpense,
        setEqualBalance
    } = useContext<IproviderFundAcc>(ProviderFundAccount);


    const handleChangeExpense = async (value: any) => {
        if(!value)
        {
            resetForm();
            return;
        }

        let lstExpense = watch("lstExpense");
        let deepCopy = _.cloneDeep(lstExpense) as ItemFundAcc[];
        let lstDup = deepCopy.filter(w=>w.sExpenseID === value.value)
        if(lstDup.length > 1 && value.value !== "19")
        {
            DialogFn.Warning("รายการ"+value.label +" มีข้อมูลอยู่แล้ว");
            resetForm();
            return;
        }

        let valueType = await handleSelectExpense(value)
        let isDisable = value.nFundExpenseID != null;
        let isOther = value.isOther;

        row.sTotal = valueType + "";
        row.isDisable = isDisable;
        row.isOther = isOther;
        row.sExpenseID = value.sExpenseID;
        row.isCanAdd = value.isCanAdd;
        form.setValue(`lstExpense.${index}.sTotal`, valueType + "")
        form.setValue(`lstExpense.${index}.isDisable`, isDisable)
        form.setValue(`lstExpense.${index}.isOther`, isOther)
        form.setValue(`lstExpense.${index}.isCanAdd`, value.isCanAdd)
        
        let sumExpense = _.sumBy(lstExpense, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
        sumExpense = Number(sumExpense.toFixed(2));
        form.setValue("sTotalExpense", sumExpense + "")
        
        let nBringForward = parseFloatCheckValue(form.getValues("sBringForward")) ?? 0;
        let nTotalIncome = parseFloatCheckValue(form.getValues("sTotalIncome")) ?? 0;
        let calBalance = nBringForward + nTotalIncome - sumExpense;
        form.setValue("sBalance", calBalance + "")
        let nTotalMoreDetail  = parseFloatCheckValue(form.getValues("sTotalMoreDetail")) ?? 0;
        setEqualBalance(calBalance === nTotalMoreDetail)

        row.sName = "";
        form.setValue(`lstExpense.${index}.sName`, "")
        if (!isOther) {
            row.sName = value.label;
            form.setValue(`lstExpense.${index}.sName`, value.label + "")
        }

        // if (!isOther) {
        //     row.sName = "";
        // }

        
    }
    
    const resetForm =()=> {
        row.sTotal = null;
        row.isDisable = false;
        row.isOther = false;
        row.sExpenseID = null;
        form.setValue(`lstExpense.${index}.sExpenseID`, null);
        form.setValue(`lstExpense.${index}.sTotal`, null);
        form.setValue(`lstExpense.${index}.isDisable`, false);
        form.setValue(`lstExpense.${index}.isOther`, false);
        form.setValue(`lstExpense.${index}.isCanAdd`, null);
    }

    return (
        <Fragment key={`${fieldName}.sID`}>
            <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
                <TableCell align="center" >{index + 1}</TableCell>
                <TableCell align="left">
                    {
                        row.isOther ?
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={4}>
                                    <SelectItem
                                        id={`${fieldName}.sExpenseID`}
                                        name={`${fieldName}.sExpenseID`}
                                        label=""
                                        required={true}
                                        IsShowMessageError={false}
                                        options={optionExpense}
                                        disabled={isView}
                                        IsPopperCustom
                                        onChange={async (value: any) => {
                                            await handleChangeExpense(value)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextBoxItem
                                        id={`${fieldName}.sName`}
                                        name={`${fieldName}.sName`}
                                        label=""
                                        required={true}
                                        maxLength={250}
                                        disabled={isView}
                                        IsShowMessageError={false}
                                        onChange={(value) => {
                                            row.sName = value;
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            :
                            <SelectItem
                                id={`${fieldName}.sExpenseID`}
                                name={`${fieldName}.sExpenseID`}
                                label=""
                                required={true}
                                IsShowMessageError={false}
                                options={optionExpense}
                                disabled={isView}
                                IsPopperCustom
                                onChange={async (value: any) => {
                                    await handleChangeExpense(value)
                                }}
                            />
                    }
                </TableCell>
                <TableCell align="right">
                    <InputReactNumber
                        id={`${fieldName}.sTotal`}
                        name={`${fieldName}.sTotal`}
                        defaultValue={row.sTotal}
                        required={true}
                        valueType='string'
                        maxDigits={2}
                        IsCanMinus={false}
                        IsShowMessageError={false}
                        disabled={row.isDisable || isHasSubLevel || isView}
                        onChange={(value) => {
                            calculateExpense(value, null)
                        }}
                    />
                </TableCell>
                <TableCell align="center">
                    {row.isCanAdd && !isView && <BtnAdd id={`btnAddExp${index}`} IsCircleWithOutText onClick={() => { handleAdd(row, null) }} />}
                    &nbsp;
                    {!isView  && <BtnDeleteTable id={`btnDeleteExp${index}`} IsCircleWithOutText onClick={() => { handleDelete(row); }} />}
                </TableCell>
            </TableRow>
            {
                isHasSubLevel ?
                    <>
                        {
                            row.lstSubLevel.map((subRow, subIndex) => {
                                const subFieldName = `lstExpense.${index}.lstSubLevel.${subIndex}`;
                                return (
                                    <TableRow key={`${subFieldName}.sID`}>
                                        <TableCell align="center" ></TableCell>
                                        <TableCell align="left" sx={{ paddingLeft: '40px !important' }}>
                                            <TextBoxItem
                                                id={`${subFieldName}.sName`}
                                                name={`${subFieldName}.sName`}
                                                label=""
                                                required={true}
                                                maxLength={250}
                                                IsShowMessageError={false}
                                                disabled={isView}
                                            />
                                        </TableCell>
                                        <TableCell align="right">
                                            <InputReactNumber
                                                id={`${subFieldName}.sTotal`}
                                                name={`${subFieldName}.sTotal`}
                                                defaultValue={row.sTotal}
                                                valueType='string'
                                                required={true}
                                                maxLength={16}
                                                maxDigits={2}
                                                disabled={isView}
                                                IsCanMinus={false}
                                                IsShowMessageError={false}
                                                onChange={(value) => {
                                                    calculateExpense(value, row.nOrder)
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                           {!isView && <BtnAdd id={`btnAddSubExp${index}`} IsCircleWithOutText onClick={() => { handleAdd(subRow, row.nOrder) }} />}
                                            &nbsp;
                                            {!isView &&<BtnDeleteTable id={`btnDeleteSubExp${index}`} IsCircleWithOutText onClick={() => { handleDelete(subRow); }} />}
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </> : null
            }
        </Fragment>

    )
}